"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const is_empty_1 = __importDefault(require("../../utils/is-empty"));
const message_defaults_json_1 = __importDefault(require("../../message-defaults.json"));
// List of terms that are not valid for physical addresses
const NON_PHYSICAL_ADDRESS_TERMS = [
    'po box',
    'p o box',
    'p.o box',
    'p.o. box',
    'private bag',
    'locked bag',
    'post box',
];
const messageDefault = message_defaults_json_1.default.physicalAddress;
const validationBuilder = (message = messageDefault) => (value) => {
    if (!(0, is_empty_1.default)(value)) {
        // Check that PO box etc (invalid address terms) are not in lines when physical address is required
        if (lodash_1.default.some(NON_PHYSICAL_ADDRESS_TERMS, (term) => lodash_1.default.includes(lodash_1.default.toLower(String(value)), term))) {
            return message;
        }
    }
    return null;
};
validationBuilder.messageDefault = messageDefault;
exports.default = validationBuilder;
